/**
 * Ir_side_nav_en
 * @constructor
 */
 class Ir_side_nav_en {
  constructor() {}
  /**
   * コモン
   */
  init() {

    if(document.URL.match('/en/')) {
      var path = location.pathname
      var pc = window.matchMedia("(min-width: 768px)").matches;
      var sp = window.matchMedia("(max-width: 767px)").matches;

      if(sp) {
        $('.js-library-ttl').attr('href','javascript:void(0)');
        $('.js-shareholder-ttl').attr('href','javascript:void(0)');
        $('.js-highlight-ttl').attr('href','javascript:void(0)');
      }
      
      // IR Library共通
      if(document.URL.match('/en/ir/library/')) {
        $('.js-library-child').show();
        $('.js-library-ttl').next().addClass('is-active');
      }
      // IR LibraryTOP
      if (path == "/en/ir/library/") {
        $('.js-library-ttl').addClass('color-orange');
      }
      
      // Shareholder Information
      if(document.URL.match('/en/ir/shareholder/')) {
        $('.js-shareholder-child').show();
        $('.js-shareholder-ttl').next().addClass('is-active');
      }
      // Shareholder InformationTOP
      if (path == "/en/ir/shareholder/") {
        $('.js-shareholder-ttl').addClass('color-orange');
      }
      // Shareholder InformationTOP > Stock Information
      if (path == "/en/ir/shareholder/stockinformation/") {
        $('.shareholder-child--01 a').addClass('color-orange');
      }
      // Shareholder InformationTOP > Shareholder meeting
      if (path == "/en/ir/shareholder/meeting/") {
        $('.shareholder-child--02 a').addClass('color-orange');
      }
      // Shareholder InformationTOP > Convocation Notice/Notice of Resolution
      if (path == "/en/ir/shareholder/notice/") {
        $('.shareholder-child--03 a').addClass('color-orange');
      }
      
      //Financial Highlights
      if(document.URL.match('/en/ir/highlight/')) {
        $('.js-highlight-child').show();
        $('.js-highlight-ttl').next().addClass('is-active');
      }
      //Financial HighlightsTOP
      if (path == "/en/ir/highlight/") {
        $('.js-highlight-ttl').addClass('color-orange');
      }
      //Financial HighlightsTOP > Financial Indicators
      if (path == "/en/ir/highlight/indicator/") {
        $('.highlight-child--01 a').addClass('color-orange');
      }
      //Financial HighlightsTOP > Consolidated Balance Sheet
      if (path == "/en/ir/highlight/bs/") {
        $('.highlight-child--02 a').addClass('color-orange');
      }
      //Financial HighlightsTOP > Consolidated Statement of Income
      if (path == "/en/ir/highlight/pl/") {
        $('.highlight-child--03 a').addClass('color-orange');
      }
      //Financial HighlightsTOP > Consolidated Statement of Cash Flows
      if (path == "/en/ir/highlight/cf/") {
        $('.highlight-child--04 a').addClass('color-orange');
      }
      
      //IR News共通
      if(document.URL.match('/en/ir/news/')) {
        $('.js-news-child').show();
      }
      //IR NewsTOP
      if (path == "/en/ir/news/") {
        $('.js-news-ttl').addClass('color-orange');
      }
      
      //Disclosure Policy共通
      if(document.URL.match('/en/ir/policy/')) {
        $('.js-news-child').show();
      }
      //Disclosure PolicyTOP
      if (path == "/en/ir/policy/") {
        $('.js-policy-ttl').addClass('color-orange');
      }
      
      //Statement of exemption from responsibility
      if(document.URL.match('/en/ir/responsibility/')) {
        $('.js-news-child').show();
      }
      //Statement of exemption from responsibility
      if (path == "/en/ir/responsibility/") {
        $('.js-responsibility-ttl').addClass('color-orange');
      }

      //IR FAQ共通
      if(document.URL.match('/en/ir/faq/')) {
        $('.js-news-child').show();
      }
      //IR FAQTOP
      if (path == "/en/ir/faq/") {
        $('.js-faq-ttl').addClass('color-orange');
      }

      if(sp) {
        $('.js-ir-side-toggle').on('click', function () {
          $(this).toggleClass('is-active');
          $(this).next().stop().slideToggle();
        })
      }
    }
  }
}

export default Ir_side_nav_en;